var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var portalUserExtService = require('./../urls').portalUserExtService;

  /**
   * Model for current portal user information. Uses the PortalUserExtService and corresponds to PortalUserDTO.
   *
   * @class CurrentPortalUserModel
   * @extends Torso.NestedModel
   * @constructor
   */
var CurrentPortalUserModel = TorsoNestedModel.extend({
  url: function() {
    return portalUserExtService + '/current~';
  }
});

module.exports = new CurrentPortalUserModel();
